import React, { Component } from 'react';
import { MultiSelect, DropdownSkeleton } from 'carbon-components-react';
import isEqual from 'lodash.isequal';
import PropTypes from 'prop-types';

export default class MultiComboBox extends Component {
    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps, this.props);
    }

    render() {

        const {
            name,
            alt,
            onChange,
            id,
            items,
            ...initProps
        } = this.props;

        const _onChange = (selectedItem) => {
            const items = selectedItem ? selectedItem.selectedItems : null;

            return this.props.onChange(name, items, alt);
        };
        return this.props.loading ? (
            <DropdownSkeleton />
        ) : (
                <MultiSelect.Filterable
                    {
                    ...initProps
                    }
                    id={'mcbx_' + id}
                    items={items || []}
                    onChange={_onChange}
                    light={false}
                    type="default"
                />
            );
    }
}

MultiComboBox.defaultProps = {
    invalid: false,
    invalidText: '',
    initialSelectedItems: [],
    disabled: true
};
